export default "__VITE_ASSET__C_CQUo0X__"